export var compKey = 'csat-survey-view';
//# sourceMappingURL=key.js.map